import { render } from "./FluidsdataAIModel.vue?vue&type=template&id=718ed952"
import script from "./FluidsdataAIModel.vue?vue&type=script&lang=js"
export * from "./FluidsdataAIModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__